module.exports = "<div\n  id=\"cxContainer\"\n  [class]=\"class + ' component ' + layout\"\n  [style.marginTop.px]=\"toolbarHeight\"\n  [style.height]=\"containerHeight\">\n    <!-- <c4-toolbar [title]=\"title\" [subtitle]=\"subtitle\"></c4-toolbar> -->\n    <ng-content></ng-content>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./~/@c4/ui/src/app/directives/container/container.directive.html
// module id = 1637
// module chunks = 2